/* @ngInject */

export default () => {
  const margin = { top: 20, right: 40, bottom: 30, left: 50 };
  const width = 960 - margin.left - margin.right;
  const height = 500 - margin.top - margin.bottom;

  return {
    restrict: 'E',
    scope: {
      height: '@',
      data: '='
    },
    link(scope, element) {
      const { data } = scope;

      const svg = d3
        .select(element[0])
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .attr('width', '100%')
        .attr('height', '100%')
        .attr(
          'viewBox',
          `0 0 ${width + margin.left + margin.right} ${
            height + margin.top + margin.bottom + 20
          }`
        )
        .attr('preserveAspectRatio', 'xMinYMin')
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      const xBar = d3.scaleBand().range([0, width]).paddingInner(0.5).paddingOuter(0.25);
      const xLine = d3.scalePoint().range([0, width]).padding(0.5);
      const yBar = d3.scaleLinear().range([height, 0]);
      const yLine = d3.scaleLinear().range([height, 0]);

      xBar.domain(data.map((d) => d.year));
      xLine.domain(data.map((d) => d.year));
      yBar.domain([0, d3.max(data, (d) => d.count)]).nice();
      yLine.domain([0, d3.max(data, (d) => d.median)]).nice();

      const rect = svg.selectAll('rect').data(data);
      rect
        .enter()
        .append('rect')
        .merge(rect)
        .attr('class', 'bar')
        .style('stroke', 'none')
        .style('fill', '#16d99e')
        .attr('x', (d) => xBar(d.year))
        .attr('width', () => xBar.bandwidth())
        .attr('y', (d) => yBar(d.count))
        .attr('height', (d) => height - yBar(d.count));

      const points = svg.selectAll('circle.point').data(data);
      points
        .enter()
        .append('circle')
        .merge(points)
        .attr('class', 'point')
        .style('stroke', 'steelblue')
        .style('fill', 'steelblue')
        .attr('cx', (d) => xLine(d.year))
        .attr('cy', (d) => yLine(d.median))
        .attr('r', () => 5);

      const line = d3
        .line()
        .x((d) => xLine(d.year))
        .y((d) => yLine(d.median))
        .curve(d3.curveCardinal);

      svg
        .append('path')
        .data([data])
        .attr('fill', 'none')
        .style('stroke-width', '2')
        .style('stroke', 'steelblue')
        .attr('d', line);

      svg.append('g').attr('transform', `translate(0,${height})`).call(d3.axisBottom(xLine));

      svg
        .append('g')
        .call(d3.axisLeft(yLine).ticks(data.length, 's'))
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '.71em')
        .style('text-anchor', 'end')
        .attr('fill', '#5D6971')
        .text('Median Sale Price');

      svg
        .append('g')
        .attr('transform', `translate( ${width}, 0 )`)
        .call(d3.axisRight(yBar))
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '-1.0em')
        .style('text-anchor', 'end')
        .attr('fill', '#5D6971')
        .text('Number of Sales');

      const legend = svg
        .selectAll('.legend')
        .data([
          { name: 'Median Price', color: 'steelblue' },
          { name: 'Total Sales', color: '#16d99e' }
        ])
        .enter()
        .append('g')
        .attr('transform', (d, i) => `translate(${-width + margin.left},${i * 20})`);

      legend
        .append('rect')
        .attr('x', width + 6)
        .attr('width', 18)
        .attr('height', 18)
        .attr('fill', (d) => d.color);

      legend
        .append('text')
        .attr('x', width + 30)
        .attr('y', 9)
        .attr('dy', '.35em')
        .style('text-anchor', 'start')
        .text((d) => d.name);
    }
  };
};
